// extracted by mini-css-extract-plugin
export default {"imageWrapper":"NK-z","twoColumnImage":"OK-z"};